import { render, staticRenderFns } from "./VQuestionExpander.vue?vue&type=template&id=ccb86912"
import script from "./VQuestionExpander.vue?vue&type=script&lang=js"
export * from "./VQuestionExpander.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports